import { render, staticRenderFns } from "./DigitalManagerGuru.vue?vue&type=template&id=1c798ee6&"
import script from "./DigitalManagerGuru.vue?vue&type=script&lang=js&"
export * from "./DigitalManagerGuru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports